import React from 'react'
import Text from '../../text/Text'
import ecoFriendlyIcon from '../../../assets/icons/icons-eco-friend.svg'

import '../../../views/configurations/EcoFriendSurvey.css'

export interface ISuccessModalProps {
    text: string
    subtitle: string
    buttonText: string
    handleOnPress: () => void
}

export default function EcoFriendSuccess(props: ISuccessModalProps) {
    return (
        <div
            style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}
        >
            <div className={'centeredIcon-survey'}>
                <img
                    src={ecoFriendlyIcon}
                    width={100}
                    style={{ marginTop: 10, marginBottom: 10 }}
                />
            </div>
            <div style={{ marginBottom: 5 }}>
                <div className={'title'}>
                    <Text
                        label={props.text}
                        variant="Body1-16 bold centeredText-survey"
                    />
                    <Text
                        label={props.subtitle}
                        variant="centeredText-survey"
                        marginBottom={20}
                    />
                </div>
                <div className={'centered'}>
                    <div
                        className={'buttonContinue-survey'}
                        onClick={props.handleOnPress}
                    >
                        <a className={'ButtonMd-14'}>{props.buttonText}</a>
                    </div>
                </div>
            </div>
        </div>
    )
}
